import axios from 'axios';
import Vue from 'vue';
import {
    AUTH_REQUEST,
    AUTH_ERROR,
    AUTH_SUCCESS,
    AUTH_LOGOUT
} from '../actions/auth';

const state = {
    token: localStorage.getItem('user-token') || '',
    status: ''
};

const getters = {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status
}

const refreshToken = async () => {
    const storedRefreshToken = localStorage.getItem('refresh-token');
    if (!storedRefreshToken) {
        throw new Error('Отсутствует refresh-токен');
    }

    try {
        const response = await Vue.axios.post('/auth/refresh', {
            refreshToken: storedRefreshToken,
        });
        const newAccessToken = response.data.accessToken;

        localStorage.setItem('user-token', newAccessToken);
        localStorage.setItem('refresh-token', response.data.refreshToken);
        axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;

        return newAccessToken;
    } catch (error) {
        console.error('Ошибка обновления refresh токена:', error);
        throw error;
    }
};

const actions = {
    [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST);
            Vue.axios.post('/auth/login', user)
                .then(resp => {
                    if (!resp.data.error) {
                        localStorage.setItem('user-token', resp.data.accessToken);
                        localStorage.setItem('refresh-token', resp.data.refreshToken);
                        localStorage.setItem('profile', JSON.stringify(resp.data.profile));
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + resp.data.accessToken;
                        commit(AUTH_SUCCESS, resp.data.accessToken);

                        Vue.axios
                            .get('/administrators/' + resp.data.profile.id + '/settings')
                            .then(resp => {
                                localStorage.setItem('settings', JSON.stringify(resp.data));
                                commit(AUTH_SUCCESS, resp);
                                resolve(resp);
                            })
                            .catch(err => {
                                console.log('Cannot load administrator\'s settings.');
                            });
                    } else {
                        resolve(resp);
                    }
                })
                .catch(err => {
                    commit(AUTH_ERROR, err);
                    localStorage.removeItem('user-token');
                    localStorage.removeItem('refresh-token');
                    localStorage.removeItem('profile');
                    localStorage.removeItem('settings');
                    reject(err);
                });
        });
    },

    [AUTH_LOGOUT]: ({ commit }) => {
        return new Promise(resolve => {
            commit(AUTH_LOGOUT);
            localStorage.removeItem('user-token');
            localStorage.removeItem('refresh-token');
            localStorage.removeItem('profile');
            localStorage.removeItem('settings');
            delete axios.defaults.headers.common['Authorization'];
            resolve();
        });
    },

    async refreshAccessToken({ commit }) {
        try {
            const token = await refreshToken();
            commit(AUTH_SUCCESS, token);
            return token;
        } catch (err) {
            commit(AUTH_ERROR);
            console.error('Ошибка при обновлении accessToken:', err);
            throw err;
        }
    },
};

const mutations = {
    [AUTH_REQUEST]: state => {
        state.status = 'loading';
    },
    [AUTH_SUCCESS]: (state, token) => {
        state.status = 'success';
        state.token = token;
    },
    [AUTH_ERROR]: state => {
        state.status = 'error';
    }
}

export default {
    state,
    getters,
    actions,
    mutations
};
